import axios from 'axios';

const THEME_KEY = 'gtdiarios_theme';

const THEME_DEFINITIONS = {
  'default': {
    '--primary': '#a259e6',
    '--primary-dark': '#6c2eb7',
    '--sidebar-bg': 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
    '--sidebar-text': '#fff',
    '--accent': '#ffd700'
  },
  'blue': {
    '--primary': '#2193b0',
    '--primary-dark': '#1a6d8f',
    '--sidebar-bg': 'linear-gradient(180deg, #2193b0 0%, #6dd5ed 100%)',
    '--sidebar-text': '#fff',
    '--accent': '#ffd700'
  },
  'green': {
    '--primary': '#43cea2',
    '--primary-dark': '#185a9d',
    '--sidebar-bg': 'linear-gradient(180deg, #43cea2 0%, #185a9d 100%)',
    '--sidebar-text': '#fff',
    '--accent': '#ffd700'
  },
  'dark': {
    '--primary': '#232526',
    '--primary-dark': '#414345',
    '--sidebar-bg': 'linear-gradient(180deg, #232526 0%, #414345 100%)',
    '--sidebar-text': '#fff',
    '--accent': '#ffd700'
  }
};

function applyCssVars(themeName) {
  const def = THEME_DEFINITIONS[themeName] || THEME_DEFINITIONS['default'];
  Object.entries(def).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
}

const state = {
  current: 'default',
  loading: false,
  error: null
};

const getters = {
  theme: s => s.current
};

const actions = {
  async loadTheme({ commit, rootState }) {
    const userId = rootState.users?.user?.id;
    const local = localStorage.getItem(THEME_KEY);
    if (!userId && local) {
      commit('setTheme', local);
      return;
    }
    try {
      commit('setLoading', true);
      const { data } = await axios.get('/user/theme', { params: { user_id: userId } });
      if (data?.theme) {
        commit('setTheme', data.theme);
        localStorage.setItem(THEME_KEY, data.theme);
      } else if (local) {
        commit('setTheme', local);
      }
    } catch (e) {
      if (local) commit('setTheme', local);
      commit('setError', e);
    } finally {
      commit('setLoading', false);
    }
  },
  async saveTheme({ commit, rootState }, themeName) {
    commit('setTheme', themeName);
    localStorage.setItem(THEME_KEY, themeName);
    const userId = rootState.users?.user?.id;
    if (!userId) return;
    try { await axios.post('/user/theme', { theme: themeName, user_id: userId }); } catch (error) { /* silent */ }
  }
};

const mutations = {
  setTheme(state, t) { state.current = t; applyCssVars(t); },
  setLoading(state, v) { state.loading = v; },
  setError(state, e) { state.error = e; }
};

export default { state, getters, actions, mutations };
